/**
 * Letters for a business's logo mark: "Demo Turf Arena" → "DT", "AK Turf" → "AK"
 * (a short all-capitals first word is kept as it is), "Arena" → "AR".
 */
export function brandInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (!words.length) return 'T'
  if (/^[A-Z0-9]{2,3}$/.test(words[0]!)) return words[0]!
  return (words.length > 1 ? words[0]![0]! + words[1]![0]! : words[0]!.slice(0, 2)).toUpperCase()
}
